<script>
export default {
  props: ['value', 'width'],
  computed: {
    active(){
      return this.$store.get('profile_filter') == this.value;
    }
  },
  methods: {
    setFilter(value){
      this.$store.set("toggleFilter", {filter: "profile_filter", value: this.value})
    }
  }
};
</script>


<template>
  <div class="filter-icon" @click="setFilter(value)" :class="{active}">
    <img :src="'./icons/'+value+'.svg'" :style="{width}"/>
    <div class="icon-label">{{value}}</div>
  </div>
</template>